import React from 'react';
import PropTypes from 'prop-types';

const Title = ({ id, title }) => {
  if (title === 'mass') {
    return <div className="text-center">Delete updates</div>;
  }

  if (title === 'single') {
    return (
      <div className="text-center">
        Delete update (Service ID:
        {' '}
        {id}
        )
      </div>
    );
  }

  return null;
};

Title.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string,
};

export default Title;
